/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import {
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
  faPython,
  faDev,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import { faAtom, faBook, faClock, faGraduationCap, faLanguage,  faUniversity } from '@fortawesome/free-solid-svg-icons'

const About = () => {
  const aboutArray = 'Education'.split('')

  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <div>
            <h1>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={aboutArray}
                idx={15}
              />
            </h1>
          </div>
          <div>
            <div style={{width:'100%',height: '100%'}}>
              <p style={{fontSize: '37px', color: "yellow"}}>👨‍🎓 Cambrain College</p>
              <p style={{fontSize: '19px'}}>- 1400 Barry Downe Rd, Greater Sudbury, ON P3A 3V8, Canada</p>
              <p style={{fontSize: '19px'}}>- From April 2015 to September 2017</p>
              <p style={{fontSize: '19px'}}>- Information Technology</p>
              {/* <img
                className="solid-logo"
                src={LogoS}
                alt="JavaScript,  Developer"
                style={{width:'100%',height: '100%'}}
              /> */}
            </div>
          </div>
        </div>
        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faUniversity} color="#4B8BBE" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faClock} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faLanguage} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faGraduationCap} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faAtom} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faBook} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
